const Reducer = (state, action) => {
    switch (action.type) {
        case "LOGIN_START":
            return {
                user: null,
                isFecting: true,
                error: false,
            };
        case "LOGIN_SUCCESS":
            return {
                user: action.payload,
                isFetching: false,
                error: false,
            };
        case "LOGIN_FAILURE":
            return {
                user: {},
                isFecting: false,
                error: true,
            };
        case "LOGOUT":
            return {
                user: {},
                isFecting: false,
                error: false,
            };
        default:
            return state;
    }
};

export default Reducer;